function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.max = null;

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (this.classList.value.includes("js-registry-item")) {
      document.addEventListener(
        "publicRegistry::loaded",
        this.updateInputMax.bind(this)
      );
    }
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.updateInputMax();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  updateInputMax() {
    const variantId = this.input.dataset.quantityVariantId;
    const registryItems = window.publicRegistry?.included;
    const theItem = registryItems?.filter(
      (p) => p.attributes.variant_id.toString() === variantId
    )[0];
    if (!theItem) return;
    const availableQuantity =
      theItem.attributes.quantity - theItem.attributes.purchased_quantity;
    this.input.setAttribute("max", availableQuantity);
    this.classList.remove("hidden");
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value < min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle &&
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const autoplay = this.getAttribute("data-autoplay") == "true";

    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    this.addEventListener("click", (e) => {
      const video = this.querySelector("video");
      const isVideoPlaying = this.getPlayingStateVideo(video);
      this.setTriggerText(isVideoPlaying);

      if (this.getAttribute("loaded")) {
        if (isVideoPlaying) {
          video.pause();
          this.setAttribute("paused", true);
          this.removeAttribute("playing");
        } else {
          video.play();
          this.setAttribute("playing", true);
          this.removeAttribute("paused");
        }
      } else {
        this.loadContent();
      }
    });

    if (autoplay) {
      this.loadContent(true, autoplay);
    }
  }

  setTriggerText(isPlaying = false) {
    const ELM_parent = this.closest(".video-section");
    const ELM_triggers = ELM_parent?.querySelectorAll(".pd-video__play-toggle");
    if (!ELM_triggers) return;

    ELM_triggers.forEach(
      (item) => (item.innerHTML = isPlaying ? "Play" : "Pause")
    );
  }

  getPlayingStateVideo(video) {
    if (!video) return false;
    return !!(
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > 2
    );
  }

  loadContent(focus = true, autoplay) {
    // window.pauseAllMedia();
    if (autoplay) {
      if (!this.getAttribute("loaded")) {
        const content = document.createElement("div");
        if (this.querySelector("template").content.firstElementChild) {
          content.appendChild(
            this.querySelector("template").content.firstElementChild.cloneNode(
              true
            )
          );
        }
        if (content.querySelector("video, model-viewer, iframe")) {
          const deferredElement = this.appendChild(
            content.querySelector("video, model-viewer, iframe")
          );
          if (focus) deferredElement.focus();

          if (
            deferredElement.nodeName == "VIDEO" &&
            deferredElement.getAttribute("autoplay")
          ) {
            // force autoplay for safari
            deferredElement.play();
            this.setAttribute("loaded", true);
            this.setAttribute("playing", true);
          }
        }
      }
    } else {
      if (!this.getAttribute("loaded")) {
        const content = document.createElement("div");
        if (this.querySelector("template").content.firstElementChild) {
          content.appendChild(
            this.querySelector("template").content.firstElementChild.cloneNode(
              true
            )
          );
        }
        this.setAttribute("loaded", true);
        if (content.querySelector("video, model-viewer, iframe")) {
          const deferredElement = this.appendChild(
            content.querySelector("video, model-viewer, iframe")
          );
          if (focus) deferredElement.focus();
          if (
            deferredElement.nodeName == "VIDEO" &&
            deferredElement.getAttribute("autoplay")
          ) {
            // force autoplay for safari
            deferredElement.play();
            this.setAttribute("playing", true);
          }
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", (e) => this.onVariantChange(e));
  }

  connectedCallback() {
    if (this.dataset.variantInitialized === "true") return;
    this.dataset.variantInitialized = "true";

    this.updateOptions();
    this.updateMasterId();
    this.updateEstimateShippingMsg();
    this.updateInputProperties();
    this.updatePaymentInstalmentMsg();

    if (!this.dataset.forCard) {
      this.updateMedia();
      this.updateVariantInput();
      this.updateShareUrl();
    }
  }

  onVariantChange(e) {
    const isForCard = this.dataset.forCard;
    this.updateOptions(e);
    this.updateMasterId();
    this.updateEstimateShippingMsg();
    this.updateInputProperties();
    this.updateShopifyBundleVariantImage(e);

    if (!isForCard) {
      if (!window.location.href.includes("/products/")) {
        this.toggleAddButton(false, "", false);
      }
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (isForCard) {
        this.updateBundleVariantId();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo(e.target);
        this.updateShareUrl();
        this.updatePaymentInstalmentMsg();
      }
    }
  }

  updateShopifyBundleVariantImage(e) {
    if (!e || !e.target) return;
    const elm = e.target;
    const ELM_wrapper = elm.closest(".product-form__input--wrapper");
    const value = elm.value;
    const ELM_variant_images =
      ELM_wrapper?.querySelector(".variant-image")?.querySelectorAll("img");
    if (!ELM_variant_images) return;
    ELM_variant_images?.forEach((elm) => {
      elm.classList.add("hidden");
    });
    if (value) {
      ELM_wrapper?.querySelector(`[data-title='${value}']`)?.classList?.remove(
        "hidden"
      );
    }
  }

  updateBundleVariantId() {
    const ELM_productCard = this.closest("[data-card-variant-id]");
    ELM_productCard.setAttribute(
      "data-card-variant-id",
      this.currentVariant.id
    );
  }

  updateOptions(e) {
    this.options = Array.from(this.querySelectorAll("select"), (select) => ({
      value: select.value,
      preorder: select.options[select.selectedIndex].getAttribute(
        "data-pre-order-variant"
      ),
      preorderMsg: select.options[select.selectedIndex].getAttribute(
        "data-pre-order-variant-msg"
      ),
      type: select
        ?.closest("[data-option-type]")
        ?.getAttribute("data-option-type"),
      checked: select.value !== "",
    }));

    const currentCheckedOption = this.options.find((option) => option.checked);

    // sync selected option with variant-radios and variant-selects
    if (
      document.querySelector("variant-radios") &&
      document
        .querySelector("variant-radios")
        .querySelector(`[value="${currentCheckedOption?.value}"]`)
    ) {
      document
        .querySelector("variant-radios")
        .querySelector(`[value="${currentCheckedOption?.value}"]`)
        .click();
    }

    const allVariantSelects = document.querySelectorAll("variant-selects");
    if (allVariantSelects.length) {
      allVariantSelects.forEach((variantSelects) => {
        const select = variantSelects.querySelector("select");
        select.value = currentCheckedOption?.value;
      });
    }

    if (!e || !e.target) {
      this.querySelectorAll("select").forEach((select) => {
        const dataId = select.getAttribute("id");
        const ELM_wrapper = this.querySelector(`[data-map-id="${dataId}"]`);
        const ELM_selectedSize = ELM_wrapper?.querySelector("[data-select-size]");
        if (ELM_selectedSize) ELM_selectedSize.innerHTML = select.value;
      });
      return;
    }

    const elm = e.target;
    const selectedValue = elm.value;
    const dataId = elm.getAttribute("id");
    const ELM_wrapper = this.querySelector(`[data-map-id="${dataId}"]`);
    const ELM_selectedSize = ELM_wrapper?.querySelector("[data-select-size]");
    if (ELM_selectedSize) ELM_selectedSize.innerHTML = selectedValue;
  }

  updatePaymentInstalmentMsg() {
    const ELM_payment_instalment_msg_val = document.getElementById(
      "payment-instalment-msg-val"
    );
    if (this.currentVariant) {
      const priceInstalment = (this.currentVariant.price / 100 / 4).toFixed(2);
      if (ELM_payment_instalment_msg_val) {
        ELM_payment_instalment_msg_val.innerHTML = priceInstalment;
      }
    }
  }

  updateMasterId() {
    const preorder = Boolean(this.getAttribute('data-pre-order'));
    const preorderProduct = Boolean(this.getAttribute('data-pre-order-product'));
    const preorderMsg = this.getAttribute('data-pre-order-msg');

    const variantData = this.getVariantData();
    if (!variantData || !variantData.length) {
      return;
    }

    // Filter out empty/null options for matching purposes
    const validOptions = this.options.filter(option => option.value && option.value !== "");
    
    const optionsString = validOptions.map(option => option.value).join(' / ');
    const preorderVariantMsgString = validOptions.map(option => option.preorderMsg).filter(option => option).join('|');
    const preorderString = validOptions.map(option => option.preorder).join('/');
    const preorderVariant = Boolean(preorderString.includes('true'));

    let newVariant = null;
    
    // exact title match
    if (optionsString) {
      newVariant = variantData.find((variant) => variant.title === optionsString);
    }

    // match by option positions correctly
    if (!newVariant && validOptions.length > 0) {
      newVariant = variantData.find((variant) => {
        return variant.options.every((option, index) =>
          validOptions[index] && validOptions[index].value === option
        );
      });
    }

    // more flexible matching - match any available variant with the selected option values
    if (!newVariant && validOptions.length > 0) {
      newVariant = variantData.find((variant) => {
        // Check if this variant contains all the selected option values
        return validOptions.every((selectedOption) => {
          return variant.options.includes(selectedOption.value);
        });
      });
    }

    // if we only have one option selected, find first available variant with that option
    if (!newVariant && validOptions.length === 1) {
      const selectedValue = validOptions[0].value;
      newVariant = variantData.find((variant) => {
        return variant.available && variant.options.includes(selectedValue);
      });
    }
    
    this.currentVariant = {
      ...newVariant,
      preorder,
      preorderProduct,
      preorderMsg,
      preorderVariant,
      preorderVariantMsgString,
    };
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const featuredMediaId = this.currentVariant.featured_media.id;
    const mediaGallery = document.querySelector(
      ".product-media-gallery__carousel"
    );
    
    if (!mediaGallery) return;
    
    const activeMedia = mediaGallery.querySelector(
      `[data-feature-media-id="${featuredMediaId}"]`
    );
    
    if (!activeMedia) return;
    
    const activeMediaWrapper = activeMedia.closest(".slick-slide");
    
    if (activeMediaWrapper?.classList.contains("slick-current")) return;
    
    if (activeMediaWrapper) {
      activeMediaWrapper.click();
    } else {
      // Slick carousel might not be initialized yet, wait and retry
      setTimeout(() => {
        const retryWrapper = activeMedia.closest(".slick-slide");
        if (retryWrapper && !retryWrapper.classList.contains("slick-current")) {
          retryWrapper.click();
        } else if (!retryWrapper) {
          // Try using Slick's API directly if available
          if ($(mediaGallery).data('slick')) {
            const slideIndex = Array.from(mediaGallery.querySelectorAll('[data-feature-media-id]')).indexOf(activeMedia);
            $(mediaGallery).slick('slickGoTo', slideIndex);
          }
        }
      }, 100);
    }
  }

  updateURL() {
    if (!this.currentVariant || !this.currentVariant.id || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl || !this.currentVariant || !this.currentVariant.id) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input && this.currentVariant && this.currentVariant.id) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    // Safety check: don't update statuses if we don't have valid data
    if (!this.variantData || !this.currentVariant) {
      return;
    }
    
    const firstCheckedInput = this.querySelector(':checked');
    if (!firstCheckedInput) {
      return;
    }
    
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => firstCheckedInput.value === variant.option1
    );
    
    // If no variants match the first option, don't disable everything
    if (selectedOptionOneVariants.length === 0) {
      return;
    }
    
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked")?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  addMultipleEventsToProductButtons() {
    const ELM_WITH_EVENTS = [
      {
        selector: "[data-add-to-lists-button]",
        callbacks: [
          (elm) => {
            elm.addEventListener("click", (e) => {
              document.dispatchEvent(
                new CustomEvent("trigger::addToLists", {
                  detail: {
                    button: elm,
                  },
                })
              );
            });
          },
          (elm) => {
            document.dispatchEvent(new CustomEvent("trigger::initLists"));
          },
        ],
      },
      {
        selector: "[data-add-to-lists-button]",
        callbacks: [
          (elm) =>
            elm.addEventListener("click", (e) => {
              document.dispatchEvent(new Event("trigger:AddToRegistry"));
            }),
          (elm) => {
            document.dispatchEvent(
              new CustomEvent("trigger::initRegistryEvents")
            );
          },
        ],
      },
    ];

    ELM_WITH_EVENTS.forEach((item) => {
      const ELM_productButton = document
        .getElementById("ProductButtons")
        .querySelector(item.selector);
      item.callbacks.forEach((cb) => cb(ELM_productButton));
    });
  }

  updateProductButtons(html) {
    document.getElementById("ProductButtons").innerHTML =
      html.getElementById("ProductButtons").innerHTML;
    this.addMultipleEventsToProductButtons();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      input.innerText = input.getAttribute("value");
      // if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
      //   input.innerText = input.getAttribute('value');
      // } else {
      //   input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      // }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    this.currentVariant?.id &&
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo(el) {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    document.getElementById("ProductButtonsLoading").classList.remove("hidden");
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );
        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        const targetOptions = Array.from(el.querySelectorAll("option")).map(
          (option) => {
            return {
              value: option.value,
              preorder: !!(
                option.getAttribute("data-pre-order-variant") == "true"
              ),
            };
          }
        );

        this.toggleAddButton(
          addButtonUpdated
            ? addButtonUpdated.hasAttribute("data-disabled")
            : true,
          window.variantStrings.soldOut
        );

        this.updateProductButtons(html);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => {
        console.error("<variant-radios></variant-radios> ", e);
        document
          .getElementById("ProductButtonsLoading")
          .classList.add("hidden");
      });
  }

  uniqItemInArr(arr) {
    return Array.from(new Set(arr));
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productFormBtns = document.querySelectorAll(
      '[id="product-form-buttons"]'
    );
    let isPreorder = this.currentVariant.preorder;
    let isPreorderProduct = this.currentVariant.preorderProduct;

    if (isPreorder != true) {
      isPreorder = this.currentVariant.preorderVariant;
    }

    if (this.currentVariant.available == false) {
      isPreorder = false;
    }

    let backInStock = disable;
    const arrStates = [
      {
        type: "back-in-stock",
        priority: 3,
      },
      {
        type: "pre-order",
        priority: 2,
      },
      {
        type: "add-to-cart",
        priority: 1,
      },
    ];

    const activeStates = arrStates.filter((item) => {
      return (
        (backInStock && item.type === "back-in-stock") ||
        (isPreorder && item.type === "pre-order") ||
        (isPreorderProduct && item.type === "pre-order")
      );
    });

    const objectType = activeStates.reduce((acc, curr) => {
      if (acc.priority > curr.priority) {
        return acc;
      } else {
        return curr;
      }
    }, {});

    const type = objectType.type;

    if (type === "pre-order") {
      productFormBtns.forEach((productFormBtn) => {
        productFormBtn.classList.value =
          "product-form__buttons product-form__buttons--preorder";
      });
    } else if (type === "back-in-stock") {
      productFormBtns.forEach((productFormBtn) => {
        productFormBtn.classList.value =
          "product-form__buttons product-form__buttons--back-in-stock";
      });
    } else {
      productFormBtns.forEach((productFormBtn) => {
        productFormBtn.classList.value = "product-form__buttons";
      });
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    // addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateInputProperties() {
    const ELM_wrapper = document.querySelector(".wrapper-preorder-properties");
    if (!ELM_wrapper) return;

    const ELM_formID = ELM_wrapper.dataset.form;
    if (
      ELM_wrapper &&
      (this.currentVariant.preorderProduct ||
        this.currentVariant.preorderVariant)
    ) {
      const inputHtml = `<input
            class="hidden"
            form="${ELM_formID}"
            type="text"
            name="properties[_preorder]"
            value="yes"
          >
          <input
            class="hidden"
            form="${ELM_formID}"
            type="text"
            name="properties[_preorder-estimate]"
            value="${
              this.currentVariant.preorderMsg
                ? this.currentVariant.preorderMsg
                : this.currentVariant.preorderVariantMsgString
            }"
          />`;
      ELM_wrapper.innerHTML = inputHtml;
    } else {
      ELM_wrapper.innerHTML = "";
    }
  }

  updateEstimateShippingMsg() {
    const ELM_estimateShippingMsg = document.querySelector(
      ".estimated-shipping-message"
    );
    if (!ELM_estimateShippingMsg) return;
    let shippingMsg = "";
    if (this.currentVariant.preorder) {
      shippingMsg = this.currentVariant.preorderMsg;
    } else {
      if (this.currentVariant.preorderVariantMsgString) {
        const preorderVariantMsgArr =
          this.currentVariant.preorderVariantMsgString.split("|");
        const filteredPreorderVariantMsgArr = this.uniqItemInArr(
          preorderVariantMsgArr
        );
        filteredPreorderVariantMsgArr.forEach((elm) => {
          elm && (shippingMsg += `<div>${elm}</div>`);
        });
      }
    }
    ELM_estimateShippingMsg.innerHTML = shippingMsg;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      // Fix: Check if a checked radio exists before accessing its value
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      );

      if (!checkedRadio) {
        // Return a default option structure if no radio is checked - but keep it in the array
        return {
          type: fieldset?.getAttribute('data-option-type'),
          value: "",
          checked: false,
          preorder: null,
          preorderMsg: null,
        };
      }

      const selectedVal = checkedRadio.value;
      const preorderVal = checkedRadio.getAttribute('data-preorder');
      const preorderMsg = checkedRadio.getAttribute('data-preorder-message');
      const selectedSize = fieldset.querySelector('[data-select-size]');
      
      if (selectedSize) {
        selectedSize.innerHTML = selectedVal;
      }

      return {
        type: fieldset?.getAttribute("data-option-type"),
        value: selectedVal,
        checked: !!fieldset.querySelector("input:checked"),
        preorder: preorderVal,
        preorderMsg: preorderMsg,
      };
    });

    // sync selected option with variant-selects
    if (
      document.querySelector('variant-selects') &&
      document.querySelector('variant-selects').querySelector('select')
    ) {
      const select = document
        .querySelector('variant-selects')
        .querySelector('select');
      const dataSelectOptionType = select
        ?.closest('[data-option-type]')
        ?.getAttribute('data-option-type');
      const checkedOption = this.options.find(
        (option) => option.checked && option.type === dataSelectOptionType
      );
      if (!checkedOption) return;
      select.value = checkedOption.value;
      
      const currentSelected = select.querySelector('[selected]');
      if (currentSelected) {
        currentSelected.removeAttribute('selected');
      }
      const newSelected = select.querySelector(
        `[value="${checkedOption.value}"]`
      );
      if (newSelected) {
        newSelected.setAttribute('selected', 'selected');
      }
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          document.dispatchEvent(
            new CustomEvent("recommendations::loaded", {
              detail: {
                isCartDrawer: !!self.closest("pd-cart-modal"),
                productHandle: self.getAttribute("product-handle"),
              },
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

//reload page when using browser back button
// window.addEventListener("pageshow", function (event) {
//   var historyTraversal =
//     event.persisted ||
//     (typeof window.performance != "undefined" &&
//       window.performance.navigation.type === 2);
//   if (historyTraversal) {
//     window.location.reload();
//   }
// });
